import { render, staticRenderFns } from "./client-back-money.vue?vue&type=template&id=6048fb79&scoped=true"
import script from "./client-back-money.vue?vue&type=script&lang=ts"
export * from "./client-back-money.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048fb79",
  null
  
)

export default component.exports